export default __webpack_public_path__ + "static/media/insta.be06e50a.svg";